export default __webpack_public_path__ + "static/step3-51b6e808d2ab63063affcd0544796ca5.svg";